export function getCurrencyHtml(currency) {
  switch(currency) {
    case 'ruble':
      return '<span class="vjs-rub">i</span>';
    case 'euro':
      return '<span class="vjs-euro">€</span>';
    case 'dollar':
      return '<span class="vjs-dollar">$</span>';
    case 'tenge':
      return '<span class="vjs-tenge"></span>';
    default: return '';
  }
}
